export default "__VITE_ASSET__DTL69IWH__"